// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Vl0Jd","head":"style_head__3t4u6"};